import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-clean-version';
export var ID = 'icon-clean-version';
/* eslint-disable max-len */

export var SVGCleanVersion = function SVGCleanVersion() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 42 15"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    width: "42",
    height: "15",
    strokeWidth: "2",
    fill: "#ffffff",
    stroke: "#4a4a4a"
  }), React.createElement("g", {
    transform: "translate(2.4406788,0.13559322)"
  }, React.createElement("path", {
    stroke: "#4a4a4a",
    strokeWidth: "0.40000001",
    fill: "#4a4a4a",
    d: "m 8.8421423,4.5158031 0,1.0049549 Q 8.3608963,5.0725387 7.8135969,4.8507881 7.2710156,4.6290374 6.6576628,4.6290374 q -1.2078332,0 -1.8494945,0.7407415 -0.6416614,0.7360233 -0.6416614,2.1325804 0,1.391839 0.6416614,2.1325805 0.6416613,0.7360232 1.8494945,0.7360232 0.6133528,0 1.1559341,-0.221751 0.5472994,-0.2217501 1.0285454,-0.6699695 l 0,0.9955185 q -0.5001184,0.339703 -1.0615721,0.509555 -0.5567356,0.169851 -1.1795246,0.169851 -1.5994353,0 -2.5194645,-0.976646 -0.9200292,-0.9813644 -0.9200292,-2.6751617 0,-1.6985154 0.9200292,-2.6751617 0.9200292,-0.9813645 2.5194645,-0.9813645 0.6322252,0 1.1889608,0.1698516 0.5614537,0.1651334 1.0521359,0.5001184 z"
  }), React.createElement("path", {
    stroke: "#4a4a4a",
    strokeWidth: "0.40000001",
    fill: "#4a4a4a",
    d: "m 10.323625,3.9732218 0.953056,0 0,6.2420442 3.430057,0 0,0.802077 -4.383113,0 0,-7.0441212 z"
  }), React.createElement("path", {
    stroke: "#4a4a4a",
    strokeWidth: "0.40000001",
    fill: "#4a4a4a",
    d: "m 15.702257,3.9732218 4.453885,0 0,0.8020767 -3.500829,0 0,2.0853994 3.354568,0 0,0.8020768 -3.354568,0 0,2.5524913 3.585755,0 0,0.802077 -4.538811,0 0,-7.0441212 z"
  }), React.createElement("path", {
    stroke: "#4a4a4a",
    strokeWidth: "0.40000001",
    fill: "#4a4a4a",
    d: "m 24.171243,4.9121233 -1.292759,3.5055471 2.590236,0 -1.297477,-3.5055471 z m -0.537863,-0.9389015 1.080444,0 2.684598,7.0441212 -0.990801,0 -0.641661,-1.8070321 -3.17528,0 -0.641662,1.8070321 -1.004955,0 2.689317,-7.0441212 z"
  }), React.createElement("path", {
    stroke: "#4a4a4a",
    strokeWidth: "0.40000001",
    fill: "#4a4a4a",
    d: "m 28.422251,3.9732218 1.283322,0 3.123382,5.8929048 0,-5.8929048 0.924747,0 0,7.0441212 -1.283323,0 -3.123381,-5.8929052 0,5.8929052 -0.924747,0 0,-7.0441212 z"
  })));
};
/* eslint-disable max-len */

var CleanVersion = function CleanVersion(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGCleanVersion
  });
};

CleanVersion.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default CleanVersion;